export default __webpack_public_path__ + "static/media/moon.eb4aedc0.svg";